import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filters: { 
      text: '',
      period: 0,
      openUvA: false 
    }
  },
  mutations: {
    setFilters: (state, data) => state.filters = data,
  },
  actions: {

  },
});
